import LoginPIVariant from './LoginPIVariant.component';
export default LoginPIVariant;